import { render, staticRenderFns } from "./saveScenario.vue?vue&type=template&id=1679d1e4&scoped=true&"
import script from "./saveScenario.vue?vue&type=script&lang=js&"
export * from "./saveScenario.vue?vue&type=script&lang=js&"
import style0 from "./saveScenario.vue?vue&type=style&index=0&id=1679d1e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1679d1e4",
  null
  
)

export default component.exports